// Real, engineer-grade villa plan GENERATED by the AutoBIM Logic backend
// (parametric generator + zero-error circulation QA - verified: entrance
// opens into the family hall, never the kitchen; ok=True, 0 violations).
// Used for the marketing product preview so visitors see genuine output.
export const SAMPLE_MODEL = {
  "extent_w": 16.0,
  "extent_h": 20.0,
  "title": "Generated Villa · فيلا مولّدة",
  "room_labels": {},
  "room_labels_pos": [
    {
      "x": 2.9,
      "y": 16.0,
      "label": "حمام رئيسي"
    },
    {
      "x": 10.0,
      "y": 5.0,
      "label": "مجلس · 32.0 م²"
    },
    {
      "x": 5.1,
      "y": 5.6,
      "label": "مدخل رئيسي"
    },
    {
      "x": 3.1,
      "y": 5.0,
      "label": "دورة مياه ضيوف"
    },
    {
      "x": 3.1,
      "y": 7.875,
      "label": "حمام 1"
    },
    {
      "x": 3.1,
      "y": 9.625,
      "label": "حمام 2"
    },
    {
      "x": 7.1,
      "y": 8.75,
      "label": "صالة · 20.3 م²"
    },
    {
      "x": 12.0,
      "y": 8.75,
      "label": "مطبخ · 14.0 م²"
    },
    {
      "x": 8.0,
      "y": 11.1,
      "w": 11.8,
      "h": 1.14,
      "zone_kind": "corridor",
      "label": "صالة التوزيع · 13.5 م²"
    },
    {
      "x": 4.363636363636363,
      "y": 14.35,
      "label": "غرفة نوم رئيسية · 25.1 م²"
    },
    {
      "x": 8.545454545454545,
      "y": 14.35,
      "label": "غرفة نوم · 19.3 م²"
    },
    {
      "x": 12.181818181818182,
      "y": 14.35,
      "label": "غرفة نوم · 19.3 م²"
    },
    {
      "x": 9.4,
      "y": 7.6,
      "w": 1.1999999999999993,
      "h": 1.1999999999999993,
      "zone_kind": "vent",
      "label": "منور إنارة الصالة"
    },
    {
      "x": 2.6,
      "y": 7.75,
      "w": 1.2000000000000002,
      "h": 1.5,
      "zone_kind": "vent",
      "label": "منور الحمامات"
    },
    {
      "x": 4.363636363636363,
      "y": 17.8,
      "w": 4.527272727272727,
      "h": 1.5,
      "zone_kind": "terrace",
      "facade": "north",
      "label": "تراس ماستر"
    },
    {
      "x": 8.545454545454545,
      "y": 17.8,
      "w": 3.436363636363636,
      "h": 1.5,
      "zone_kind": "terrace",
      "facade": "north",
      "label": "تراس غرفة 2"
    },
    {
      "x": 12.181818181818182,
      "y": 17.8,
      "w": 3.436363636363636,
      "h": 1.5,
      "zone_kind": "terrace",
      "facade": "north",
      "label": "تراس غرفة 3"
    },
    {
      "x": 6.0,
      "y": 2.2,
      "w": 7.8,
      "h": 1.5,
      "zone_kind": "terrace",
      "facade": "south",
      "label": "تراس المجلس"
    }
  ],
  "entry_markers": [
    {
      "x": 5.1,
      "y": 2.4,
      "dx": 0.0,
      "dy": 1.0,
      "label": "غرفة نوم رئيسية"
    }
  ],
  "structural_meta": {
    "structural_system": "rc_frame",
    "code_profile": "SBC",
    "floors": 1,
    "column_size_m": 0.3,
    "max_bay_span_m": 6.0,
    "columns_required": true,
    "basis": "preliminary_rule_based",
    "note": "تقدير أولي قائم على قواعد إرشادية لأغراض التصميم المبدئي وحصر الكميات فقط - ليس بديلاً عن تحليل إنشائي مُرخّص للأحمال (الجاذبية والرياح والزلازل) وتقرير التربة؛ يجب اعتماد المقاطع والتباعد والتسليح من مهندس إنشائي مرخّص. Preliminary rule-based estimate for early design / BoQ only - a licensed structural engineer must verify column sizes, spacing and reinforcement against the real loads, wind/seismic and soil report before construction."
  },
  "layout_meta": {
    "plot_m2": 320.0,
    "footprint_m2": 205.2,
    "coverage_pct": 64.1,
    "functional_rooms": 14,
    "circulation_spaces": 2,
    "light_wells": 2,
    "logical_distribution": true,
    "grade": "excellent",
    "grade_ar": "ممتاز",
    "note": "توزيع منطقي هندسي: وصول لكل الغرف عبر ممرات/موزعات، ومنور للغرف الداخلية، ونسبة بناء مدروسة على الأرض. Logical engineering distribution: every room reached via corridors/distributors, light-wells for interior rooms, and a studied plot coverage."
  },
  "building_meta": {
    "has_basement": false,
    "basement_depth_m": 0.0,
    "has_front_shops": false,
    "num_front_shops": 0
  },
  "walls": [
    {
      "id": "w-2cdc695d",
      "kind": "wall",
      "p1": {
        "x": 2.0,
        "y": 3.0
      },
      "p2": {
        "x": 2.0,
        "y": 7.0
      },
      "thickness": 0.25,
      "wall_type": "exterior",
      "label": null,
      "openings": [],
      "length_m": 4.0
    },
    {
      "id": "w-31c057b3",
      "kind": "wall",
      "p1": {
        "x": 2.0,
        "y": 7.0
      },
      "p2": {
        "x": 2.0,
        "y": 10.5
      },
      "thickness": 0.25,
      "wall_type": "exterior",
      "label": null,
      "openings": [
        "win-c79d6d46"
      ],
      "length_m": 3.5
    },
    {
      "id": "w-6ae38b2f",
      "kind": "wall",
      "p1": {
        "x": 2.0,
        "y": 11.7
      },
      "p2": {
        "x": 2.0,
        "y": 17.0
      },
      "thickness": 0.25,
      "wall_type": "exterior",
      "label": null,
      "openings": [
        "win-06f44d31"
      ],
      "length_m": 5.3
    },
    {
      "id": "w-44293665",
      "kind": "wall",
      "p1": {
        "x": 14.0,
        "y": 3.0
      },
      "p2": {
        "x": 14.0,
        "y": 7.0
      },
      "thickness": 0.25,
      "wall_type": "exterior",
      "label": null,
      "openings": [],
      "length_m": 4.0
    },
    {
      "id": "w-ebcf6efd",
      "kind": "wall",
      "p1": {
        "x": 14.0,
        "y": 7.0
      },
      "p2": {
        "x": 14.0,
        "y": 10.5
      },
      "thickness": 0.25,
      "wall_type": "exterior",
      "label": null,
      "openings": [
        "win-384ede7e"
      ],
      "length_m": 3.5
    },
    {
      "id": "w-c84fbbe2",
      "kind": "wall",
      "p1": {
        "x": 14.0,
        "y": 11.7
      },
      "p2": {
        "x": 14.0,
        "y": 17.0
      },
      "thickness": 0.25,
      "wall_type": "exterior",
      "label": null,
      "openings": [
        "win-b7171170"
      ],
      "length_m": 5.3
    },
    {
      "id": "w-b0e5d9b3",
      "kind": "wall",
      "p1": {
        "x": 6.0,
        "y": 3.0
      },
      "p2": {
        "x": 14.0,
        "y": 3.0
      },
      "thickness": 0.25,
      "wall_type": "exterior",
      "label": null,
      "openings": [
        "win-0a5ea9db"
      ],
      "length_m": 8.0
    },
    {
      "id": "w-4dcf122f",
      "kind": "wall",
      "p1": {
        "x": 4.2,
        "y": 3.0
      },
      "p2": {
        "x": 6.0,
        "y": 3.0
      },
      "thickness": 0.25,
      "wall_type": "exterior",
      "label": null,
      "openings": [
        "d-87292290"
      ],
      "length_m": 1.8
    },
    {
      "id": "w-2bb1e513",
      "kind": "wall",
      "p1": {
        "x": 2.0,
        "y": 3.0
      },
      "p2": {
        "x": 4.2,
        "y": 3.0
      },
      "thickness": 0.25,
      "wall_type": "exterior",
      "label": null,
      "openings": [
        "win-9df456cd"
      ],
      "length_m": 2.2
    },
    {
      "id": "w-de759a92",
      "kind": "wall",
      "p1": {
        "x": 2.0,
        "y": 17.0
      },
      "p2": {
        "x": 6.727,
        "y": 17.0
      },
      "thickness": 0.25,
      "wall_type": "exterior",
      "label": null,
      "openings": [
        "win-4a1cd2c6"
      ],
      "length_m": 4.727
    },
    {
      "id": "w-3330e900",
      "kind": "wall",
      "p1": {
        "x": 6.727,
        "y": 17.0
      },
      "p2": {
        "x": 10.364,
        "y": 17.0
      },
      "thickness": 0.25,
      "wall_type": "exterior",
      "label": null,
      "openings": [
        "win-8135be68"
      ],
      "length_m": 3.637
    },
    {
      "id": "w-423d1c99",
      "kind": "wall",
      "p1": {
        "x": 10.364,
        "y": 17.0
      },
      "p2": {
        "x": 14.0,
        "y": 17.0
      },
      "thickness": 0.25,
      "wall_type": "exterior",
      "label": null,
      "openings": [
        "win-85839775"
      ],
      "length_m": 3.636
    },
    {
      "id": "w-b16cfb7a",
      "kind": "wall",
      "p1": {
        "x": 2.0,
        "y": 10.5
      },
      "p2": {
        "x": 2.0,
        "y": 11.7
      },
      "thickness": 0.25,
      "wall_type": "exterior",
      "label": null,
      "openings": [
        "win-96c8fe71"
      ],
      "length_m": 1.2
    },
    {
      "id": "w-8383d718",
      "kind": "wall",
      "p1": {
        "x": 14.0,
        "y": 10.5
      },
      "p2": {
        "x": 14.0,
        "y": 11.7
      },
      "thickness": 0.25,
      "wall_type": "exterior",
      "label": null,
      "openings": [
        "win-f4287152"
      ],
      "length_m": 1.2
    },
    {
      "id": "w-257e642d",
      "kind": "wall",
      "p1": {
        "x": 2.0,
        "y": 15.0
      },
      "p2": {
        "x": 3.8,
        "y": 15.0
      },
      "thickness": 0.12,
      "wall_type": "interior",
      "label": null,
      "openings": [
        "d-cd743d66"
      ],
      "length_m": 1.8
    },
    {
      "id": "w-73d6d4bb",
      "kind": "wall",
      "p1": {
        "x": 3.8,
        "y": 15.0
      },
      "p2": {
        "x": 3.8,
        "y": 17.0
      },
      "thickness": 0.12,
      "wall_type": "interior",
      "label": null,
      "openings": [],
      "length_m": 2.0
    },
    {
      "id": "w-e6fd62cc",
      "kind": "wall",
      "p1": {
        "x": 2.0,
        "y": 7.0
      },
      "p2": {
        "x": 14.0,
        "y": 7.0
      },
      "thickness": 0.12,
      "wall_type": "interior",
      "label": null,
      "openings": [
        "d-9f344099"
      ],
      "length_m": 12.0
    },
    {
      "id": "w-fecb7df0",
      "kind": "wall",
      "p1": {
        "x": 2.0,
        "y": 10.5
      },
      "p2": {
        "x": 14.0,
        "y": 10.5
      },
      "thickness": 0.12,
      "wall_type": "interior",
      "label": null,
      "openings": [
        "d-04ea2db0"
      ],
      "length_m": 12.0
    },
    {
      "id": "w-80b5d57d",
      "kind": "wall",
      "p1": {
        "x": 2.0,
        "y": 11.7
      },
      "p2": {
        "x": 14.0,
        "y": 11.7
      },
      "thickness": 0.12,
      "wall_type": "interior",
      "label": null,
      "openings": [
        "d-a39556dd",
        "d-3dae6c87",
        "d-f62580eb"
      ],
      "length_m": 12.0
    },
    {
      "id": "w-06a6c8d9",
      "kind": "wall",
      "p1": {
        "x": 4.2,
        "y": 3.0
      },
      "p2": {
        "x": 4.2,
        "y": 7.0
      },
      "thickness": 0.12,
      "wall_type": "interior",
      "label": null,
      "openings": [
        "d-9452913c"
      ],
      "length_m": 4.0
    },
    {
      "id": "w-599c221f",
      "kind": "wall",
      "p1": {
        "x": 6.0,
        "y": 3.0
      },
      "p2": {
        "x": 6.0,
        "y": 7.0
      },
      "thickness": 0.12,
      "wall_type": "interior",
      "label": null,
      "openings": [
        "d-0e176265"
      ],
      "length_m": 4.0
    },
    {
      "id": "w-f4ca76d4",
      "kind": "wall",
      "p1": {
        "x": 4.2,
        "y": 7.0
      },
      "p2": {
        "x": 4.2,
        "y": 10.5
      },
      "thickness": 0.12,
      "wall_type": "interior",
      "label": null,
      "openings": [
        "d-06c38844",
        "d-cf7e2d1d"
      ],
      "length_m": 3.5
    },
    {
      "id": "w-6a180952",
      "kind": "wall",
      "p1": {
        "x": 10.0,
        "y": 7.0
      },
      "p2": {
        "x": 10.0,
        "y": 10.5
      },
      "thickness": 0.12,
      "wall_type": "interior",
      "label": null,
      "openings": [
        "d-1fe7b73c"
      ],
      "length_m": 3.5
    },
    {
      "id": "w-75a35576",
      "kind": "wall",
      "p1": {
        "x": 2.0,
        "y": 8.75
      },
      "p2": {
        "x": 4.2,
        "y": 8.75
      },
      "thickness": 0.12,
      "wall_type": "interior",
      "label": null,
      "openings": [],
      "length_m": 2.2
    },
    {
      "id": "w-f9a0f714",
      "kind": "wall",
      "p1": {
        "x": 6.727,
        "y": 11.7
      },
      "p2": {
        "x": 6.727,
        "y": 17.0
      },
      "thickness": 0.12,
      "wall_type": "interior",
      "label": null,
      "openings": [],
      "length_m": 5.3
    },
    {
      "id": "w-a2be8b4f",
      "kind": "wall",
      "p1": {
        "x": 10.364,
        "y": 11.7
      },
      "p2": {
        "x": 10.364,
        "y": 17.0
      },
      "thickness": 0.12,
      "wall_type": "interior",
      "label": null,
      "openings": [],
      "length_m": 5.3
    },
    {
      "id": "w-c980e0a8",
      "kind": "wall",
      "p1": {
        "x": 8.8,
        "y": 7.0
      },
      "p2": {
        "x": 8.8,
        "y": 8.2
      },
      "thickness": 0.12,
      "wall_type": "interior",
      "label": null,
      "openings": [
        "win-a6d06c21"
      ],
      "length_m": 1.2
    },
    {
      "id": "w-0b677e0e",
      "kind": "wall",
      "p1": {
        "x": 8.8,
        "y": 8.2
      },
      "p2": {
        "x": 10.0,
        "y": 8.2
      },
      "thickness": 0.12,
      "wall_type": "interior",
      "label": null,
      "openings": [],
      "length_m": 1.2
    },
    {
      "id": "w-540d4925",
      "kind": "wall",
      "p1": {
        "x": 3.2,
        "y": 7.0
      },
      "p2": {
        "x": 3.2,
        "y": 8.5
      },
      "thickness": 0.12,
      "wall_type": "interior",
      "label": null,
      "openings": [
        "win-fbbb8063"
      ],
      "length_m": 1.5
    },
    {
      "id": "w-d995c088",
      "kind": "wall",
      "p1": {
        "x": 2.0,
        "y": 8.5
      },
      "p2": {
        "x": 3.2,
        "y": 8.5
      },
      "thickness": 0.12,
      "wall_type": "interior",
      "label": null,
      "openings": [],
      "length_m": 1.2
    },
    {
      "id": "w-3c01e015",
      "kind": "wall",
      "p1": {
        "x": 2.1,
        "y": 18.55
      },
      "p2": {
        "x": 6.627,
        "y": 18.55
      },
      "thickness": 0.1,
      "wall_type": "interior",
      "label": null,
      "openings": [],
      "length_m": 4.527
    },
    {
      "id": "w-9920caf0",
      "kind": "wall",
      "p1": {
        "x": 2.1,
        "y": 17.05
      },
      "p2": {
        "x": 2.1,
        "y": 18.55
      },
      "thickness": 0.1,
      "wall_type": "interior",
      "label": null,
      "openings": [],
      "length_m": 1.5
    },
    {
      "id": "w-db1d5261",
      "kind": "wall",
      "p1": {
        "x": 6.627,
        "y": 17.05
      },
      "p2": {
        "x": 6.627,
        "y": 18.55
      },
      "thickness": 0.1,
      "wall_type": "interior",
      "label": null,
      "openings": [],
      "length_m": 1.5
    },
    {
      "id": "w-8234a1ef",
      "kind": "wall",
      "p1": {
        "x": 6.827,
        "y": 18.55
      },
      "p2": {
        "x": 10.264,
        "y": 18.55
      },
      "thickness": 0.1,
      "wall_type": "interior",
      "label": null,
      "openings": [],
      "length_m": 3.437
    },
    {
      "id": "w-fa4e7824",
      "kind": "wall",
      "p1": {
        "x": 6.827,
        "y": 17.05
      },
      "p2": {
        "x": 6.827,
        "y": 18.55
      },
      "thickness": 0.1,
      "wall_type": "interior",
      "label": null,
      "openings": [],
      "length_m": 1.5
    },
    {
      "id": "w-aeb527c4",
      "kind": "wall",
      "p1": {
        "x": 10.264,
        "y": 17.05
      },
      "p2": {
        "x": 10.264,
        "y": 18.55
      },
      "thickness": 0.1,
      "wall_type": "interior",
      "label": null,
      "openings": [],
      "length_m": 1.5
    },
    {
      "id": "w-499bedb5",
      "kind": "wall",
      "p1": {
        "x": 10.464,
        "y": 18.55
      },
      "p2": {
        "x": 13.9,
        "y": 18.55
      },
      "thickness": 0.1,
      "wall_type": "interior",
      "label": null,
      "openings": [],
      "length_m": 3.436
    },
    {
      "id": "w-fa1507c9",
      "kind": "wall",
      "p1": {
        "x": 10.464,
        "y": 17.05
      },
      "p2": {
        "x": 10.464,
        "y": 18.55
      },
      "thickness": 0.1,
      "wall_type": "interior",
      "label": null,
      "openings": [],
      "length_m": 1.5
    },
    {
      "id": "w-04a0b2af",
      "kind": "wall",
      "p1": {
        "x": 13.9,
        "y": 17.05
      },
      "p2": {
        "x": 13.9,
        "y": 18.55
      },
      "thickness": 0.1,
      "wall_type": "interior",
      "label": null,
      "openings": [],
      "length_m": 1.5
    },
    {
      "id": "w-9806bd69",
      "kind": "wall",
      "p1": {
        "x": 2.1,
        "y": 1.45
      },
      "p2": {
        "x": 9.9,
        "y": 1.45
      },
      "thickness": 0.1,
      "wall_type": "interior",
      "label": null,
      "openings": [],
      "length_m": 7.8
    },
    {
      "id": "w-d54d4139",
      "kind": "wall",
      "p1": {
        "x": 2.1,
        "y": 2.95
      },
      "p2": {
        "x": 2.1,
        "y": 1.45
      },
      "thickness": 0.1,
      "wall_type": "interior",
      "label": null,
      "openings": [],
      "length_m": 1.5
    },
    {
      "id": "w-96465ad6",
      "kind": "wall",
      "p1": {
        "x": 9.9,
        "y": 2.95
      },
      "p2": {
        "x": 9.9,
        "y": 1.45
      },
      "thickness": 0.1,
      "wall_type": "interior",
      "label": null,
      "openings": [],
      "length_m": 1.5
    }
  ],
  "openings": [
    {
      "id": "d-87292290",
      "kind": "door",
      "wall_id": "w-4dcf122f",
      "offset_from_p1": 0.9,
      "width": 1.2,
      "height": 2.1,
      "label": "المدخل الرئيسي",
      "swing": "in",
      "leaf_side": "p1"
    },
    {
      "id": "d-cd743d66",
      "kind": "door",
      "wall_id": "w-257e642d",
      "offset_from_p1": 1.35,
      "width": 0.8,
      "height": 2.1,
      "label": "باب حمام الماستر",
      "swing": "in",
      "leaf_side": "p1"
    },
    {
      "id": "win-4a1cd2c6",
      "kind": "window",
      "wall_id": "w-de759a92",
      "offset_from_p1": 3.264,
      "width": 1.8,
      "height": 1.2,
      "label": "نافذة الماستر",
      "sill_m": 0.9
    },
    {
      "id": "win-8135be68",
      "kind": "window",
      "wall_id": "w-3330e900",
      "offset_from_p1": 1.818,
      "width": 1.8,
      "height": 1.2,
      "label": "نافذة غرفة 2",
      "sill_m": 0.9
    },
    {
      "id": "win-85839775",
      "kind": "window",
      "wall_id": "w-423d1c99",
      "offset_from_p1": 1.818,
      "width": 1.8,
      "height": 1.2,
      "label": "نافذة غرفة 3",
      "sill_m": 0.9
    },
    {
      "id": "win-0a5ea9db",
      "kind": "window",
      "wall_id": "w-b0e5d9b3",
      "offset_from_p1": 4.0,
      "width": 2.2,
      "height": 1.2,
      "label": "نافذة المجلس",
      "sill_m": 0.9
    },
    {
      "id": "win-9df456cd",
      "kind": "window",
      "wall_id": "w-2bb1e513",
      "offset_from_p1": 1.1,
      "width": 0.6,
      "height": 1.2,
      "label": "نافذة WC",
      "sill_m": 0.9
    },
    {
      "id": "win-c79d6d46",
      "kind": "window",
      "wall_id": "w-31c057b3",
      "offset_from_p1": 1.75,
      "width": 1.2,
      "height": 1.2,
      "label": "نافذة الحمام",
      "sill_m": 0.9
    },
    {
      "id": "win-384ede7e",
      "kind": "window",
      "wall_id": "w-ebcf6efd",
      "offset_from_p1": 1.75,
      "width": 1.8,
      "height": 1.2,
      "label": "نافذة المطبخ",
      "sill_m": 0.9
    },
    {
      "id": "win-06f44d31",
      "kind": "window",
      "wall_id": "w-6ae38b2f",
      "offset_from_p1": 2.65,
      "width": 1.8,
      "height": 1.2,
      "label": "نافذة الماستر الجانبية",
      "sill_m": 0.9
    },
    {
      "id": "win-b7171170",
      "kind": "window",
      "wall_id": "w-c84fbbe2",
      "offset_from_p1": 2.65,
      "width": 1.2,
      "height": 1.2,
      "label": "نافذة الغرفة الجانبية",
      "sill_m": 0.9
    },
    {
      "id": "win-96c8fe71",
      "kind": "window",
      "wall_id": "w-b16cfb7a",
      "offset_from_p1": 0.6,
      "width": 1.2,
      "height": 1.2,
      "label": "منور موزع - يسار",
      "sill_m": 0.9
    },
    {
      "id": "win-f4287152",
      "kind": "window",
      "wall_id": "w-8383d718",
      "offset_from_p1": 0.6,
      "width": 1.2,
      "height": 1.2,
      "label": "منور موزع - يمين",
      "sill_m": 0.9
    },
    {
      "id": "d-0e176265",
      "kind": "door",
      "wall_id": "w-599c221f",
      "offset_from_p1": 2.4,
      "width": 1.2,
      "height": 2.1,
      "label": "باب المجلس",
      "swing": "in",
      "leaf_side": "p1"
    },
    {
      "id": "d-9452913c",
      "kind": "door",
      "wall_id": "w-06a6c8d9",
      "offset_from_p1": 2.0,
      "width": 0.8,
      "height": 2.1,
      "label": "باب WC ضيوف",
      "swing": "in",
      "leaf_side": "p1"
    },
    {
      "id": "d-9f344099",
      "kind": "door",
      "wall_id": "w-e6fd62cc",
      "offset_from_p1": 3.1,
      "width": 1.2,
      "height": 2.1,
      "label": "المدخل → الصالة",
      "swing": "in",
      "leaf_side": "p1"
    },
    {
      "id": "d-04ea2db0",
      "kind": "door",
      "wall_id": "w-fecb7df0",
      "offset_from_p1": 6.0,
      "width": 1.2,
      "height": 2.1,
      "label": "الصالة → ممر الغرف",
      "swing": "in",
      "leaf_side": "p1"
    },
    {
      "id": "d-06c38844",
      "kind": "door",
      "wall_id": "w-f4ca76d4",
      "offset_from_p1": 0.875,
      "width": 0.8,
      "height": 2.1,
      "label": "باب الحمام",
      "swing": "in",
      "leaf_side": "p1"
    },
    {
      "id": "d-1fe7b73c",
      "kind": "door",
      "wall_id": "w-6a180952",
      "offset_from_p1": 2.45,
      "width": 0.9,
      "height": 2.1,
      "label": "باب المطبخ",
      "swing": "in",
      "leaf_side": "p1"
    },
    {
      "id": "d-cf7e2d1d",
      "kind": "door",
      "wall_id": "w-f4ca76d4",
      "offset_from_p1": 2.625,
      "width": 0.8,
      "height": 2.1,
      "label": "باب الحمام 2",
      "swing": "in",
      "leaf_side": "p1"
    },
    {
      "id": "d-a39556dd",
      "kind": "door",
      "wall_id": "w-80b5d57d",
      "offset_from_p1": 2.364,
      "width": 0.9,
      "height": 2.1,
      "label": "باب غرفة 1",
      "swing": "in",
      "leaf_side": "p1"
    },
    {
      "id": "d-3dae6c87",
      "kind": "door",
      "wall_id": "w-80b5d57d",
      "offset_from_p1": 6.545,
      "width": 0.9,
      "height": 2.1,
      "label": "باب غرفة 2",
      "swing": "in",
      "leaf_side": "p1"
    },
    {
      "id": "d-f62580eb",
      "kind": "door",
      "wall_id": "w-80b5d57d",
      "offset_from_p1": 10.182,
      "width": 0.9,
      "height": 2.1,
      "label": "باب غرفة 3",
      "swing": "in",
      "leaf_side": "p1"
    },
    {
      "id": "win-a6d06c21",
      "kind": "window",
      "wall_id": "w-c980e0a8",
      "offset_from_p1": 0.6,
      "width": 0.9,
      "height": 1.2,
      "label": "نافذة منور إنارة الصالة · Hall light-well",
      "sill_m": 0.9
    },
    {
      "id": "win-fbbb8063",
      "kind": "window",
      "wall_id": "w-540d4925",
      "offset_from_p1": 0.75,
      "width": 0.9,
      "height": 1.2,
      "label": "نافذة منور الحمامات · Bath light-well",
      "sill_m": 0.9
    }
  ],
  "columns": [
    {
      "id": "c-6e03992a",
      "kind": "column",
      "centre": {
        "x": 2.15,
        "y": 3.15
      },
      "width": 0.3,
      "depth": 0.3,
      "label": "Column"
    },
    {
      "id": "c-5617cfbb",
      "kind": "column",
      "centre": {
        "x": 13.85,
        "y": 3.15
      },
      "width": 0.3,
      "depth": 0.3,
      "label": "Column"
    },
    {
      "id": "c-42c1f653",
      "kind": "column",
      "centre": {
        "x": 2.15,
        "y": 16.85
      },
      "width": 0.3,
      "depth": 0.3,
      "label": "Column"
    },
    {
      "id": "c-88a44abb",
      "kind": "column",
      "centre": {
        "x": 13.85,
        "y": 16.85
      },
      "width": 0.3,
      "depth": 0.3,
      "label": "Column"
    },
    {
      "id": "c-c2e6645d",
      "kind": "column",
      "centre": {
        "x": 6.0,
        "y": 7.0
      },
      "width": 0.3,
      "depth": 0.3,
      "label": "Column"
    },
    {
      "id": "c-ee88e48e",
      "kind": "column",
      "centre": {
        "x": 4.2,
        "y": 10.5
      },
      "width": 0.3,
      "depth": 0.3,
      "label": "Column"
    },
    {
      "id": "c-b0628ae0",
      "kind": "column",
      "centre": {
        "x": 10.0,
        "y": 10.5
      },
      "width": 0.3,
      "depth": 0.3,
      "label": "Column"
    },
    {
      "id": "c-76528bcc",
      "kind": "column",
      "centre": {
        "x": 8.0,
        "y": 3.15
      },
      "width": 0.3,
      "depth": 0.3,
      "label": "Column"
    },
    {
      "id": "c-f120d5e0",
      "kind": "column",
      "centre": {
        "x": 8.0,
        "y": 16.85
      },
      "width": 0.3,
      "depth": 0.3,
      "label": "Column"
    }
  ],
  "stairs": []
};
